<template>
  <div>
    <grid ref='grid' :config="gridConfig" class="no-grid-border"/>
    <modal-edit :config="{id: gridConfig.id, api: 'RFQ2s/Get/'}" :formModel="formModel" :isHighPermission="isHighPermission"/>
  </div>
</template>

<script>
import gridConfigHighPermission from './GridConfigHighPermission'
import gridConfigLowPermission from './GridConfigLowPermission'
import { waitValue } from '@/utils/promises.js'

export default {
  name: 'QuickRFQ2Index',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-edit': () => import(/* webpackChunkName: 'QuickRFQ2' */ './ModalEdit')
  },
  props: {
    partNumber: { type: String },
    eventID: { required: true },
    formModel: { type: Function, required: true }
  },
  created () {
    this.$bus.$on(`on-created-${this.eventID}`, this.refresh)
  },
  beforeDestroy () {
    this.$bus.$off(`on-created-${this.eventID}`, this.refresh)
  },
  watch: {
    partNumber () {
      this.getGrid()
        .then((grid) => {
          const filterID = 'string-filter-rfq2'
          grid.setToolbarFilter(filterID, this.partNumber || '')
        })
    }
  },
  computed: {
    isHighPermission () {
      return this.$store.getters.isHighPermission
    },
    gridConfig () {
      return this.isHighPermission
        ? gridConfigHighPermission
        : gridConfigLowPermission
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    refresh () {
      this.getGrid()
        .then(grid => {
          grid.refresh()
        })
    }
  }
}
</script>
